import React from "react";
import { CustomOutlinedDisabledTextField } from "../../../../../partials/content/Forms";
import { Badge, Card } from "react-bootstrap";
const LeadBasicInfo = ({ lead }) => {
  return (
    <React.Fragment>
      <div className="row">
        <div className="col-sm-12 col-md-12 col-lg-12">
          <Card>
            <Card.Header>
              <i className="fas fa-th-large"></i>
              <span>
                <strong>Lead Basic Info</strong>
              </span>
              {lead.ID > 0 ? (
                <Badge
                  className="float-right ml-1"
                  variant={
                    lead.leadStatus === 1
                      ? "primary"
                      : lead.leadStatus === 2
                      ? "success"
                      : null
                  }
                >
                  {lead.leadStatus !== 0 ? lead.leadStatusDesc : null}
                </Badge>
              ) : null}
            </Card.Header>
            <Card.Body>
              <div className="row">
                <div className="col-sm-4 col-md-4 col-lg-4">
                  <CustomOutlinedDisabledTextField
                    label="Lead Name"
                    value={lead.leadName}
                  />
                  <CustomOutlinedDisabledTextField
                    label="Customer Group"
                    value={lead.customerGroupName}
                  />
                  <CustomOutlinedDisabledTextField
                    label="Contact Name"
                    value={lead.contactName}
                  />
                  <CustomOutlinedDisabledTextField
                    label="Position"
                    value={lead.position}
                  />
                  <CustomOutlinedDisabledTextField
                    label="Website"
                    value={lead.website}
                  />
                  <CustomOutlinedDisabledTextField
                    label="Taxpayer Identification Number"
                    value={lead.taxpayerID}
                  />
                </div>
                <div className="col-sm-4 col-md-4 col-lg-4">
                  <CustomOutlinedDisabledTextField
                    label="Phone Number"
                    value={lead.contactPhone}
                  />
                  <CustomOutlinedDisabledTextField
                    label="Email"
                    value={lead.contactEmail}
                  />
                  <CustomOutlinedDisabledTextField
                    label="Industry Type"
                    value={lead.industryType.industryTypeName}
                  />
                  <CustomOutlinedDisabledTextField
                    label="Business Size"
                    value={lead.businessSize.businessSizeName}
                  />
                  <CustomOutlinedDisabledTextField
                    label="Source"
                    value={lead.source.sourceName}
                  />
                  <CustomOutlinedDisabledTextField
                    label="Priority"
                    value={lead.priority.priorityName}
                  />
                </div>
                <div className="col-sm-4 col-md-4 col-lg-4">
                  <CustomOutlinedDisabledTextField
                    label="Address"
                    value={lead.address}
                  />
                  <CustomOutlinedDisabledTextField
                    label="City"
                    value={lead.city}
                  />
                  <CustomOutlinedDisabledTextField
                    label="Province / State"
                    value={lead.province}
                  />
                  <CustomOutlinedDisabledTextField
                    label="Country"
                    value={lead.countryName}
                  />
                  <CustomOutlinedDisabledTextField
                    label="Postal Code"
                    value={lead.postalCode}
                  />
                  <CustomOutlinedDisabledTextField
                    label="Assigned To"
                    value={lead.assignedUserName}
                  />
                </div>
              </div>
              <CustomOutlinedDisabledTextField
                label="Description"
                value={lead.description}
                multiline
                minRows={5}
              />
            </Card.Body>
          </Card>
        </div>
      </div>
    </React.Fragment>
  );
};

export default LeadBasicInfo;
